import { Observable } from 'rxjs';

// Usage Analytics Response
export interface UsageAnalytics {
    total_requests: number;
    unique_sessions: number;
    daily_breakdown: DailyBreakdown[];
    start_date: string;
    end_date: string;
    timestamp: string;
}

export interface DailyBreakdown {
    date: string;
    requests: number;
    sessions: number;
}

// Session Analytics Response
export interface SessionAnalytics {
    total_sessions: number;
    avg_messages_per_session: number;
    session_length_distribution: { [key: string]: number };
    start_date: string;
    end_date: string;
    timestamp: string;
}

// Performance Analytics Response
export interface PerformanceAnalytics {
    avg_response_time_ms: number;
    p50_response_time_ms: number;
    p95_response_time_ms: number;
    by_agent: { [agentName: string]: AgentPerformance };
    start_date: string;
    end_date: string;
    timestamp: string;
}

export interface AgentPerformance {
    avg_ms: number;
    count: number;
}

// Feedback Analytics Response
export interface FeedbackAnalytics {
    total_feedback_count: number;
    positive_count: number;
    negative_count: number;
    satisfaction_rate: number;
    by_agent: { [agentName: string]: AgentFeedback };
    by_language: { [language: string]: LanguageFeedback };
    timestamp: string;
}

export interface AgentFeedback {
    positive: number;
    negative: number;
    rate: number;
}

export interface LanguageFeedback {
    positive: number;
    negative: number;
    rate: number;
}

export abstract class CollectsAiAnalyticsBase {
    abstract getUsageAnalytics(orgTag: string, startDate?: string, endDate?: string): Observable<UsageAnalytics>;

    abstract getSessionAnalytics(orgTag: string, startDate?: string, endDate?: string): Observable<SessionAnalytics>;

    abstract getPerformanceAnalytics(orgTag: string, startDate?: string, endDate?: string): Observable<PerformanceAnalytics>;

    abstract getFeedbackAnalytics(orgTag: string, startDate?: string, endDate?: string): Observable<FeedbackAnalytics>;
}
